import Route from '@ember/routing/route';

export default class ComplaintsPolicy extends Route {
  // normal class body definition here
}
